import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import "./ProjectDetails.css";
const ProjectDetails = () => {
  const { id } = useParams();
  const [projects, setProjects] = useState({});
  useEffect(() => {
    fetch("/projectsData.json")
      .then((res) => res.json())
      .then((data) => {
        const findData = data.find((project) => project.id === id);
        console.log(findData);
        if (findData) {
          setProjects(findData);
        }
      });
  }, [id]);

  return (
    <div className="container my-5">
      <h2
        className="my-4 text-warning"
        style={{ borderBottom: "2px solid orange", lineHeight: "55px", textAlign: "left" }}
      >
        <span className="text-white text-uppercase">{projects?.title}</span> - {projects?.subtitle}
      </h2>
      <div className="row d-flex align-items-center">
        <div className="col-md-6">
          <h4 className="text-center text-uppercase mb-3 text-warning">Full Page</h4>
          <img src={projects?.img1} alt="" className="img-fluid" />
        </div>
        <div className="col-md-6">
          <div className="row g-5">

            {projects?.id &&
              <div className="col-md-12">
                <h4 className="text-center mb-3 text-uppercase text-warning">Some Specific Pages</h4>
                <img src={projects?.img2} className="img-fluid" alt="" />
              </div>
            }
            {projects?.id &&
              <div className="col-md-12">
                <img src={projects?.img3} className="img-fluid" alt="" />
              </div>
            }
            {projects?.id &&
              <div className="col-md-12">
                <img src={projects?.img4} className="img-fluid" alt="" />
              </div>
            }
          </div>
        </div>
        <h2 className="text-center text-uppercase mt-5 mb-3" style={{ borderBottom: "2px solid orange", lineHeight: "55px", textAlign: "left" }}>Overviews</h2>
        <h3 className="text-warning">Features:</h3>
        <ul className="ms-4">
          <li>{projects?.feature1}</li>
          <li>{projects?.feature2}</li>
          <li>{projects?.feature3}</li>
          <li>{projects?.feature4}</li>
          <li>{projects?.feature5}</li>
        </ul>
        <h3 className="text-warning">Technology Used:</h3>
        <p>{projects?.technology}</p>
        <div className="d-flex mt-3">
          <h3 className="text-warning me-3">Previews:</h3>
          <a href={projects?.livesite} className="button type1 pt-2" > <i className="fas fa-record-vinyl"></i> Live site</a>
          <a href={projects?.clientcode} className="button type1 pt-2 mx-3" ><i className="fab fa-github"></i> Client Side</a>
          <a href={projects?.servercode} className="button type1 pt-2" > <i className="fab fa-github"></i> Server Side</a>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
